import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { retry, catchError, finalize } from 'rxjs/operators';
import { HelperService } from './services/helper.service';
import { env } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HeaderPlanter implements HttpInterceptor {
  authReq: any;
  constructor(private helperService: HelperService, private toastr: ToastrService) { }
  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    this.helperService.setLoading(true);
    if (req.url.includes('https://eoriginal-wsdl')) {
      this.authReq = req.clone({
        headers: new HttpHeaders({
          'api-key': env.eOAPIKEY
        })
      });
    } else {
      this.authReq = req.clone({
        headers: new HttpHeaders({
          'mss-api-key': env.mssKey
        })
      });
    }
    return next.handle(this.authReq)
      .pipe(retry(1), finalize(() => this.helperService.setLoading(false)), catchError((error: HttpErrorResponse) => {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        // this.toastr.error(errorMessage, 'Server Error');
        return throwError(error);
      }))
  }
}
